<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.managers', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.lastName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('nom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="errorshasField('nom')">
                                        {{ getErrorsField('nom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="lastName-group"
                                        :label="$t('message.firstName')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.prenom.$model"
                                            :state="$v.form.prenom.$dirty ? !(errorshasField('prenom') || $v.form.prenom.$error) : null"
                                            type="text"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('prenom')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.prenom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('prenom')">
                                        {{ getErrorsField('prenom') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>
                            <b-col sm="3">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="indicatif-group"
                                        :label="$t('message.indicatif')"
                                        label-for="indicatif"
                                >
                                    <b-form-input
                                            id="indicatif"
                                            v-model="$v.form.indicatif.$model"
                                            :state="$v.form.indicatif.$dirty ? !($v.form.indicatif.$error) : null"
                                            required
                                            placeholder=""
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.numeric">
                                        {{ $t('message.integer', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.indicatif.maxLength">
                                        {{ $t('message.maxCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
<!--                                    <b-form-invalid-feedback v-if="!$v.form.telephone.integer">-->
<!--                                        {{ $t('message.integer', { n: 9 }) }}-->
<!--                                    </b-form-invalid-feedback>-->
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.numeric">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>


                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.email.$model"
                                            :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                            type="email"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="civility-group"
                                        :label="$t('message.civility')"
                                        label-for="civility">
                                    <b-form-select
                                            id="civility"
                                            v-model="$v.form.civilite.$model"
                                            :state="$v.form.civilite.$dirty ? !(errorshasField('civilite') || $v.form.civilite.$error) : null"
                                            :options="civilites"
                                            required
                                            @focus="clearErrorField('civilite')"
                                    ></b-form-select>

                                    <b-form-invalid-feedback v-if="!$v.form.civilite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('civilite')">
                                        {{ getErrorsField('civilite') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="nationalite-group"
                                        :label="$t('message.nationality')"
                                        label-for="nationalite"
                                >
                                    <b-form-input
                                            id="nationalite"
                                            v-model="form.nationalite"
                                            :state="$v.form.nationalite.$dirty ? !(errorshasField('nationalite') || $v.form.nationalite.$error) : null"
                                            @focus="clearErrorField('nationalite')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('nationalite')">
                                        {{ getErrorsField('nationalite') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.nationalite.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="singleAddManager-group"
                                        :label="$t('message.select')+' '+$tc('message.countries', 1)"
                                        label-for="singleAddManager">
                                    <!-- Options -->
                                    <select id="singleAddManager"  v-model="form.pays" required
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option v-for="item in mCountries" :value="item.value" :key="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>

                                    <b-form-invalid-feedback v-if="errorshasField('pays')">
                                        {{ getErrorsField('pays') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.pays.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>

                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="ville-group"
                                        :label="$tc('message.cities', 1)"
                                        label-for="ville"
                                >
                                    <b-form-input
                                            id="ville"
                                            v-model="form.ville"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            @focus="clearErrorField('ville')"
                                            required
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">

                                <b-form-group
                                        id="street-group"
                                        :label="$t('message.street')"
                                        label-for="street"
                                >
                                    <b-form-input
                                            id="street"
                                            v-model="$v.form.quartier.$model"
                                            :state="$v.form.quartier.$dirty ? !(errorshasField('quartier') || $v.form.quartier.$error) : null"
                                            @focus="clearErrorField('quartier')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('quartier')">
                                        {{ getErrorsField('quartier') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="zipCode-group"
                                        :label="$t('message.zipCode')"
                                        label-for="zipCode"
                                >
                                    <b-form-input
                                            id="zipCode"
                                            v-model="$v.form.code_postal.$model"
                                            :state="$v.form.code_postal.$dirty ? !(errorshasField('code_postal') || $v.form.code_postal.$error) : null"
                                            @focus="clearErrorField('code_postal')"
                                            type="number"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('code_postal')">
                                        {{ getErrorsField('code_postal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="6">

                                <b-form-group
                                        id="address-group"
                                        :label="$t('message.address')"
                                        label-for="address"
                                >
                                    <b-form-input
                                            id="address"
                                            v-model="$v.form.adresse.$model"
                                            :state="$v.form.adresse.$dirty ? !(errorshasField('adresse') || $v.form.adresse.$error) : null"
                                            @focus="clearErrorField('adresse')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="errorshasField('adresse')">
                                        {{ getErrorsField('adresse') }}
                                    </b-form-invalid-feedback>

<!--                                    <b-form-invalid-feedback v-if="!$v.form.adresse.required">-->
<!--                                        {{ $t('message.requiredField') }}-->
<!--                                    </b-form-invalid-feedback>-->

                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button  @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger" v-if="can">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {required, email, minLength, integer, maxLength, numeric} from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "AddManager",

        computed: {
            ...mapGetters(["countries", "errors",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            }
        },

        data() {
            return {
                form: {
                    nom: '',
                    prenom:'',
                    adresse:'',
                    telephone: '',
                    email: '',
                    civilite: '',
                    indicatif: '',
                    nationalite: '',
                    ville: '',
                    pays: '',
                    quartier: '',
                    code_postal: '',
                },
                civilites: [
                    { value: 'Mme/Mlle.', text: 'Mme/Mlle.' },
                    { value: 'M.', text: 'M.' },
                    { value: 'Dr.', text: 'Dr.' },
                    { value: 'Pr.', text: 'Pr.' }
                ],
                show: true
            }
        },

        methods: {
            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        nom: this.form.nom,
                        prenom: this.form.prenom,
                        email: this.form.email,
                        telephone: this.form.indicatif+this.form.telephone,
                        civilite: this.form.civilite,
                        nationalite: this.form.nationalite,
                        ville: this.form.ville,
                        adresse: this.form.adresse,
                        quartier: this.form.quartier,
                        code_postal: this.form.code_postal,
                        pays: this.form.pays,
                        isMedicasure:'1'
                    };

                    let successMessage = this.$i18n.t('message.managerCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createManager', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';
                this.form.prenom = '';
                this.form.email = '';
                this.form.telephone = '';
                this.form.civilite = '';
                this.form.nationalite = '';
                this.form.ville = '';
                this.form.pays = '';
                this.form.adresse = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nom: {
                    required
                },
                prenom: {
                    //
                },
                indicatif: {
                    required,
                    maxLength: maxLength(3),
                    numeric
                },
                telephone: {
                    required,
                    integer,
                    minLength: minLength(9),
                    numeric
                },
                email: {
                    required,
                    email
                },
                civilite: {
                    required
                },
                nationalite: {
                    required
                },
                ville: {
                    required
                },
                quartier: {
                    //
                },
                code_postal: {
                    //
                },
                adresse: {
                    // required
                },
                pays: {
                    required
                }
            }
        },

        mounted() {
            // Retrieve list of countries
            this.getCountries();

            new SlimSelect({
                select: '#singleAddManager',
                placeholder: 'Select your country'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>